import { Check } from 'lucide-react';
import { cn } from './lib/cn';

export type Step = { label: string; description?: string };

export function Stepper({
  steps,
  current,
  className,
}: {
  steps: Step[];
  current: number;
  className?: string;
}) {
  return (
    <ol
      className={cn(
        'flex w-full flex-col gap-4 sm:flex-row sm:items-start sm:gap-0',
        className
      )}
    >
      {steps.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li
            key={i}
            className='flex flex-1 items-start gap-3 sm:flex-col sm:items-center sm:text-center'
          >
            <div className='flex flex-col items-center sm:w-full sm:flex-row'>
              <div
                className={cn(
                  'grid h-8 w-8 shrink-0 place-items-center rounded-full border-2 text-sm font-semibold',
                  done && 'bg-brand-orange border-brand-orange text-white',
                  active && 'border-brand-orange text-brand-orange bg-brand-orange-100',
                  !done && !active && 'border-border text-muted-foreground bg-card'
                )}
              >
                {done ? <Check className='h-4 w-4' /> : i + 1}
              </div>
              {i < steps.length - 1 && (
                <div
                  className={cn(
                    'mx-2 hidden h-0.5 flex-1 sm:block',
                    done ? 'bg-brand-orange' : 'bg-border'
                  )}
                />
              )}
            </div>
            <div className='sm:mt-2'>
              <div
                className={cn(
                  'text-sm font-semibold',
                  done || active ? 'text-brand-navy' : 'text-muted-foreground'
                )}
              >
                {s.label}
              </div>
              {s.description && (
                <div className='text-xs text-muted-foreground'>{s.description}</div>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
